export default __webpack_public_path__ + "static/randy-moser-d89daf419a99035910e0d4f6dc28147a.webp";